import { Field } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { postcodeAddSpaceSanity } from "../../../components/InputFields/sanitizer/inputSanitizers";
import TextInput from "../../../components/InputFields/TextInput";
import { V1, V4, V5, V10, V21 } from "../../../components/InputFields/validator/validators";
import { AddressSearchData } from "../searchDupDlpPolicy/SearchDupDlpPolicy.state";
import styles from "./SearchByAddressFields.module.scss";

interface Props {
  fields: Record<string, Field<string>>;
  handleUpdateAddress: (data: Partial<AddressSearchData>) => void;
  values: Partial<AddressSearchData>;
}

export const SearchByAddressFields = ({ fields, handleUpdateAddress, values }: Props) => {
  const onChangePostalCode = (postalCode: string) => {
    handleUpdateAddress({ postalCode });
  };

  const onChangeHouseNumber = (houseNumber: string) => {
    handleUpdateAddress({ houseNumber });
  };

  const onChangeHouseNumberAddition = (houseNumberAddition: string) => {
    handleUpdateAddress({ houseNumberAddition });
  };

  return (
    <div className={styles.searchByAddressFields__wrapper}>
      <TextInput
        fieldData={fields}
        name="Postcode"
        fieldName="Postcode"
        sanitize={[postcodeAddSpaceSanity]}
        validators={[V5, V10(7), V21]}
        propertyName="adr.Postalcode"
        onChange={onChangePostalCode}
        onBlur={onChangePostalCode}
        widthClassName="medium"
        excludeRow={true}
        inputValue={values.postalCode}
      />
      <TextInput
        fieldData={fields}
        name="HouseNumber"
        fieldName="HouseNumber"
        validators={[V1, V5]}
        propertyName="HouseNumber"
        onBlur={onChangeHouseNumber}
        widthClassName="medium"
        excludeRow={true}
        inputValue={values.houseNumber}
      />
      <TextInput
        fieldData={fields}
        name="HouseNumberAddition"
        fieldName="HouseNumberAddition"
        validators={[V4, V10(15)]}
        propertyName="HouseNumberAddition"
        onBlur={onChangeHouseNumberAddition}
        widthClassName="medium"
        excludeRow={true}
        inputValue={values.houseNumberAddition}
      />
    </div>
  );
};
